import styles from './DeletedReportPage.module.scss';
import { Text } from '../components/typography';

const image =
  'https://opas-public.s3.us-east-2.amazonaws.com/graphics/robot/robot_hiding.jpg';

export default function DeletedReportPage() {
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <Text noMargin size="lg" weight="semiBold" textAlign="center">
          Looks like this page has been archived 🗄️
        </Text>
        <img src={image} alt="deleted" className={styles.image} />
        <Text noMargin textAlign="center" weight="semiBold">
          Or you may not have access...
        </Text>
        <Text textAlign="center">
          If you need further assistance, or think this is a mistake - reach out
          to your administrator or contact us at{' '}
          <a href="mailto:support@opasmobile.com" className={styles.link}>
            support@opasmobile.com
          </a>
        </Text>
      </div>
    </div>
  );
}
